/*
Defines the custom element <ravel-carousel>
*/

import { RavelCarousel } from './src/RavelCarousel.js';

customElements.define('ravel-carousel', RavelCarousel);
